import { axiosInstance } from "../config";

export default {
  state: {
    Lead: [],
    AllLeads: [],
    leads_archived: [],
    leads_unarchived: [],
  },
  mutations: {
    SetLead(state, payload) {
      state.Lead = payload;
    },
    SetAllLeads(state, payload) {
      state.AllLeads = payload;
    },
    SetLeadsArchived(state, payload) {
      state.leads_archived = payload;
    },
    SetLeadsUnarchived(state, payload) {
      state.leads_unarchived = payload;
    },
  },
  actions: {
    async Get_Lead_by_ID({ commit }, payload) {
      return await axiosInstance
        .get(`/leads/${payload?.id}`)
        .then(function (data) {
          commit("SetLead", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Get_Leads({ commit }) {
      return await axiosInstance
        .get("/leads")
        .then(function (data) {
          commit("SetAllLeads", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Get_Leads_Archived({ commit }) {
      return await axiosInstance
        .get("/leads/archived")
        .then(function (data) {
          commit("SetLeadsArchived", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Get_Leads_Unarchived({ commit }) {
      return await axiosInstance
        .get("/leads/unarchived")
        .then(function (data) {
          commit("SetLeadsUnarchived", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Patch_Leads_Toggle_Archived(commit, payload) {
      return await axiosInstance
        .patch("/leads/" + payload?.id + "/toggle_archived")
        .then(function (data) {
          return data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Post_Leads({}, payload) {
      return await axiosInstance
        .post("/leads", payload)
        .then(function (data) {
          return data.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Put_Leads_Edit(commit, payload) {
      return await axiosInstance
        .put("/leads/" + payload?.id, payload?.data)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Delete_Leads_by_ID(commit, payload) {
      return await axiosInstance
        .delete("/leads/" + payload?.id)
        .then(function (data) {
          return data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
  },
  getters: {
    get_lead: (state) => state.Lead,
    get_all_Leads: (state) => state.AllLeads,
    get_leads_archived: (state) => state.leads_archived,
    get_leads_unarchived: (state) => state.leads_unarchived,
  },
};
